(function (ng) {
    /// <summary>
    /// Controller for evo trip booking form
    /// </summary>
    /// <param name="$scope">angular $scope</param>
    /// <param name="travelerService">Service for retrieving travelers</param>
    /// <param name="tripInformationService">Service for retrieving evo trip details</param>
    ng.module('evo.Trip.Controllers').controller('bookingController', [
        '$scope',
        '$window',
        '$location',
        'cartService',
        'travelerService',
        'tripInformationService',
        function (
            $scope,
            $window,
            $location,
            cartService,
            travelerService,
            tripInformationService
        ) {
            var FORM_SELECTOR = 'form[name=bookForm]',
                status = {
                    loading: false,
                    submitted: false,
                    hasErrors: false,
                    soldOut: false,
                    unavailable: false,
                    response: ''
                },
                model = {
                    CoreTaxonomyNodeId: 0,
                    CustomerReferral: '',
                    ItemId: 0,
                    ProductId: 0,
                    QuestionsAndConcerns: '',
                    RelativePath: '',
                    TripName: '',
                    Travelers: [],
                    WaiverAccepted: false,
                    BrandName: ''
                },
                selectors = {
                    tripTile: '.js-trip-tile'
                };

            $(selectors.tripTile).each(function () {
                var $tile = $(this);
                var tripId = $tile.data('tripId');
                tripInformationService.get(tripId).then(function (response) {
                    $tile.data('inventory', response.Inventory);

                    // Prioritize unavailable messaging over sold out messaging
                    if (response.Unavailable) {
                        $tile.addClass('unavailable');
                    } else if (response.Inventory === 0) {
                        $tile.addClass('sold-out');
                    }
                });
            });

            // Get the SKU for the currently selected trip
            function updateTripInformation() {
                var tripId = $window.location.hash.split('#').pop();
                if (tripId) {
                    loadTripInformation(tripId).then(function (response) {
                        if (response) {
                            updateEvoTripAffirmMessaging($scope.trip.Price);
                            updateEvoTripAffirmBooking(
                                $scope.trip.Price * model.Travelers.length
                            );
                            dataLayerManager.pushTripView(response.SKU, response);
                        }
                        if ($scope.trip.DisplayAffirm) {
                            affirm.ui.ready(function () {
                                affirm.ui.refresh();
                            });
                        }
                    });
                }
            }

            // function that updates the affirm price on booking form
            function updateEvoTripAffirmBooking(price) {
                var affirmDisplay = document.getElementById('evotrip-affirm-booking');

                if (!affirmDisplay) {
                    return;
                }

                $(affirmDisplay).attr('data-amount', parseFloat(price * 100).toFixed());
                if (!$scope.trip.DisplayAffirm || price < 50) {
                    affirmDisplay.style.display = 'none';
                } else {
                    affirmDisplay.style.display = 'block';
                }
            }

            // function that updates the affirm promotion messaging
            function updateEvoTripAffirmMessaging(price) {
                var affirmBookingBox = document.getElementById(
                    'evotrip-affirm-buy-box'
                );
                var affirmPageBottom = document.getElementById(
                    'evotrip-affirm-page-bottom'
                );

                if (!affirmBookingBox) {
                    return;
                }

                $(affirmBookingBox).attr(
                    'data-amount',
                    parseFloat(price * 100).toFixed()
                );
                $(affirmPageBottom).attr(
                    'data-amount',
                    parseFloat(price * 100).toFixed()
                );
                if (
                    !$scope.trip.DisplayAffirm ||
                    price < 50 ||
                    status.soldOut ||
                    status.unavailable
                ) {
                    affirmBookingBox.style.display = 'none';
                    affirmPageBottom.style.display = 'none';
                } else {
                    affirmBookingBox.style.display = 'block';
                    affirmPageBottom.style.display = 'block';
                }
            }

            // Get trip details for the specified sku
            function loadTripInformation(tripId) {
                var relativePath = $window.location.pathname.startsWith('/en-ca/')
                    ? $window.location.pathname.replace('/en-ca', '')
                    : $window.location.pathname;
                return tripInformationService.get(tripId).then(function (trip) {
                    if (trip) {
                        $scope.trip = trip;
                        model.CoreTaxonomyNodeId = trip.CoreTaxonomyNodeId;
                        model.CustomerReferral = trip.TripReason;
                        model.ItemId = trip.ItemId;
                        model.ProductId = trip.ProductId;
                        model.RelativePath = relativePath;
                        model.SKU = trip.SKU;
                        model.TripName = trip.Name;
                        model.BrandName = trip.BrandName;
                        status.soldOut = !trip.Inventory || trip.Inventory <= 0;
                        status.unavailable = trip.Unavailable;

                        $('.js-trip-buy-box').toggleClass(
                            'unavailable',
                            status.unavailable
                        );
                        $('.js-trip-buy-box').toggleClass(
                            'sold-out',
                            status.soldOut && !status.unavailable
                        );

                        // Set buy box pricing
                        $('.js-trip-original-price').text(
                            trip.MSRP === trip.Price ? '' : formatPrice(trip.MSRP)
                        );
                        $('.js-trip-actual-price').text(formatPrice(trip.Price));
                        return trip;
                    }
                });
            }

            // Function to format a dollar amount into a price string
            function formatPrice(amount) {
                return numeral(amount).format();
            }

            // Re-parse the form validation and display errors
            function reparseForm(selector) {
                var $form = $(selector)
                    .removeData('validator')
                    .removeData('unobtrusiveValidation');
                $.validator.unobtrusive.parse($form);
                return $form;
            }

            // Add a new traveler
            $scope.addTraveler = function () {
                model.Travelers.push(travelerService.getNewTraveler());
                updateTripInformation();
            };

            // Remove the traveler at index
            $scope.removeTraveler = function (index) {
                model.Travelers.splice(index, 1);
                updateTripInformation();
            };

            // When submitting the form, validate data
            $scope.onSubmit = function (action) {
                var $form = reparseForm(FORM_SELECTOR);
                if (!$form.valid()) {
                    var $modal = $('#dynamic-modal'),
                        offsetModal = $modal.offset().top,
                        offsetMessage = $('.error-message:visible')
                            .first()
                            .closest('.js-input-section')
                            .offset().top;

                    $modal.animate({
                        scrollTop: offsetMessage + $modal.scrollTop() - offsetModal
                    });
                    return;
                }

                model.OriginalPrice = $scope.trip.OriginalPrice;
                model.CurrentPrice = $scope.trip.Price;
                model.TotalCost = model.CurrentPrice * model.Travelers.length;
                model.TripDate = $scope.trip.Date;
                status.loading = true;

                cartService.book(model).then(
                    function (result) {
                        if (result === false) {
                            status.hasErrors = true;
                        } else {
                            status.submitted = true;
                            status.hasErrors = false;

                            // close booking modal
                            $('#dynamic-modal').remove();

                            // redirect page to checkout or cart
                            let path = $.ApplicationPath();

                            path += '/cart';
                            $window.location.href = path;
                        }

                        status.loading = false;
                    },
                    function (result) {
                        status.hasErrors = true;
                        status.loading = false;
                    }
                );
            };

            // There should always be at least 1 traveler
            $scope.addTraveler();

            $scope.model = model;
            $scope.status = status;

            $($window).on('hashchange', function () {
                updateTripInformation();
                $scope.$apply();
            });
            updateTripInformation();
        }
    ]);
})(angular);
